import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../../lib/utils";

type Tone = "fat" | "carbs" | "protein" | "blue" | "neutral";

const trackColor: Record<Tone, string> = {
  fat: "bg-gold",
  carbs: "bg-teal",
  protein: "bg-protein",
  blue: "bg-blue",
  neutral: "bg-ink-muted",
};

export interface SliderProps
  extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  tone?: Tone;
  thumbLabels?: string[];
}

export const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, tone = "neutral", thumbLabels, ...props }, ref) => {
  const thumbs = props.value?.length ?? props.defaultValue?.length ?? 1;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex h-5 w-full touch-none select-none items-center",
        props.disabled && "opacity-40",
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-line">
        <SliderPrimitive.Range
          className={cn("absolute h-full", trackColor[tone])}
        />
      </SliderPrimitive.Track>
      {Array.from({ length: thumbs }, (_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          aria-label={thumbLabels?.[i] ?? `Wert ${i + 1}`}
          className={cn(
            "block h-4 w-4 rounded-full border-2 bg-surface-card shadow-card focus:outline-none focus:ring-2 focus:ring-offset-2",
            tone === "fat" && "border-gold",
            tone === "carbs" && "border-teal",
            tone === "protein" && "border-protein",
            tone === "blue" && "border-blue",
            tone === "neutral" && "border-ink-muted",
          )}
        />
      ))}
    </SliderPrimitive.Root>
  );
});
Slider.displayName = "Slider";
